import React, { useState,useCallback,useEffect } from 'react';
import { Anchor, Drawer, Button,Menu, Dropdown, Avatar } from 'antd';
import logo from '../../assets/images/logo.png'
import {UnlockOutlined,UserOutlined,SnippetsOutlined,CodeOutlined,DownOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import { useSelector,useDispatch } from "react-redux";
import { logout } from "../../features/auth";
const { Link } = Anchor;

function AppHeader() {
  const [visible, setVisible] = useState(false);
  const [loggedIn, setLoggedIn] = useState(true);
  const navigate = useNavigate();
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  
 console.log(currentUser?.ClientEmail);
  const logOut =() => {
    navigate('/')
    dispatch(logout());
  };
  
  function viewProfile(){
    navigate('/Profile')
  }
  function viewAdminPanel(){
    navigate('/AdminPanel')
  }
  const menu = (
    <Menu style={{margin:10}}>
    <Menu.ItemGroup>
      <Menu.Item onClick={()=>{logOut()}}><UnlockOutlined /> Log Out</Menu.Item>
      {currentUser?.ClientEmail==="admin@chaperone.co.ls"?<Menu.Item onClick={()=>{viewAdminPanel()}}><UserOutlined /> Admin Panel</Menu.Item>:
      <Menu.Item onClick={()=>{viewProfile()}}><UserOutlined /> My Profile</Menu.Item>}
    </Menu.ItemGroup>
  </Menu>
  );
  const menu2 = (
    <Menu style={{margin:10}}>
    <Menu.ItemGroup>
      <Menu.Item>
        <a href={process.env.REACT_APP_BASE_URL+'index.html'} target='blank'>
        <CodeOutlined /> Swagger
        </a>
        </Menu.Item>
      <Menu.Item>
        <a href={process.env.REACT_APP_BASE_URL+'redoc/index.html'} target='blank'>
        <SnippetsOutlined /> Redoc
        </a>
        </Menu.Item>
    </Menu.ItemGroup>
  </Menu>
  );
  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <div className="container-fluid">
      <div className="header" >
        <div className="logo">
          <a href="#">
            <img src={logo} width='200'/>
          </a>
        </div>
        <div className="mobileHidden">
          <Anchor targetOffset="65">
            <Link href="./" title="Home" />
            <Link href="./Documentation" title="Documentation" />
            <Dropdown overlay={menu2}>
             <p title="API SandBox">API SandBox <DownOutlined /></p>
            </Dropdown>
            {/* <Link href="/Products" title="Products" /> */}
            <Link href="./FAQS" title="FAQ" />
            <Link href="./Contact" title="Contact" />
            {currentUser?(
                      <Dropdown overlay={menu}>
                          <h4 title={currentUser.ContactPerson}><Avatar size={25} icon={<UserOutlined />}/> {currentUser.ContactPerson}</h4>
                      </Dropdown>):(<Link href="./SignIn" title="Sign In" />)} 
          </Anchor>
        </div>
        <div className="mobileVisible">
          <Button style={{backgroundColor:'#00b33c',color:'white'}} onClick={showDrawer}>
            <i className="fas fa-bars"></i>
          </Button>
          <Drawer
            placement="right"
            closable={false}
            onClose={onClose}
            visible={visible}
            ><Anchor targetOffset="65">
              <Link href="./" title="Home"/>
              <Link href="./Documentation" title="Documentation"/>
              <Link href="./Sandbox" title="API SandBox" />
              <Link href="./Products" title="Products"/>
              <Link href="./FAQS" title="FAQ"/>
              <Link href="./Contact" title="Contact"/>
            {currentUser?(
                      <Dropdown overlay={menu}>
                          <h4 title={currentUser.ContactPerson}><Avatar size={25} icon={<UserOutlined />}/> {currentUser.ContactPerson}</h4>
                      </Dropdown>):(<Link href="./SignIn" title="Sign In" />)} 
            </Anchor>
          </Drawer>
        </div>
      </div>
    </div>
  );
}

export default AppHeader;